<template>
  <div class="main-forum">
    <div class="video-hall">
      <div class="page-header-banner"></div>
      <div class="video-part">
        <div class="video-title">
          <div>主论坛LIVE大厅</div>
          <span>LIVE STUDIO</span>
        </div>
        <VideoComponent
          :timeList="mainTimeList"
          mainTitle="主论坛议程"
          :areaId="7"
        />
      </div>
    </div>

    <div class="agenda-list">
      <div class="common-forum-agenda sub-forum-guests">
        <div class="main-title">
          <div class="first-item"></div>
          <div>
            <span style="letter-spacing:10px;">主论坛嘉宾</span>
            <span style="letter-spacing:2px;">FORUM GUESTS</span>
          </div>
        </div>
        <div class="sub-guests">
          <div
            v-for="(item, indexG) in guestsList"
            :key="indexG"
            class="li_list"
          >
            <div class="sub-guests-info">
              <div class="sub-guests-name">{{ item.name }}</div>
              <div class="sub-guests-position">{{ item.company }}</div>
              <div class="sub-guests-position">{{ item.position }}</div>
              <div class="sub-forum-title">{{ item.title }}</div>
            </div>
            <img :src="item.img" alt />
          </div>
        </div>
      </div>
      <div class="common-forum-agenda sub-forum-guests">
        <div class="main-title">
          <div class="first-icon"></div>
          <div>
            <span style="letter-spacing:25px;">合作伙伴</span>
            <span style="letter-spacing:5px;">PARTNERSHIP</span>
          </div>
        </div>
        <div class="main-timetable coop-partner">
          <div v-for="item of partnershipList" :key="item.img">
            <img :src="item.img" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="common-forum-agenda meeting-bg">
      <div style="width:1200px;margin:0 auto">
        <div class="main-title meeting-justify">
          <div class="second-icon"></div>
          <div>
            <span style="letter-spacing:25px;">会务信息</span>
            <span style="letter-spacing:0;">MEETING MESSAGE</span>
          </div>
        </div>
        <div class="main-timetable conference-info">
          <div class="hs-logo"></div>
          <div class="hs-qr-code"></div>
          <div class="contant-int">
            <div>
              会务咨询：
              <span>戚女士 0571-26693359</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VideoComponent from "./components/videoCom";

export default {
  data() {
    return {
      partnershipList: [],
      guestsList: [],
      liveStatus: -1, //直播状态
      mainTimeList: [] //主论坛时间表
    };
  },
  computed: {},
  components: {
    VideoComponent
  },
  created() {
    // 页面加载时，主要有一个关键点，那就是直播和录播的场景区分，先从cms上加载议程数据，赋予播放器第一条议程的视频地址（如果有）作为初值，
    // 然后从获取直播信息的接口中获取当前论坛信息，判断当前是否在直播,如果在直播则切换播放器的地址
    this.getMainTimeList();
    this.getForumGuests();
    this.getPartnershipList();
    // this.queryLiveStatus();
  },
  mounted() {},
  methods: {
    //从cms上获取主论坛时间
    getMainTimeList() {
      axios({
        url:
          "/r/cms/www/itn/json/deveConference/mainTimeList.json?time=" +
          +new Date(),
        method: "get",
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        withCredentials: true
      }).then(res => {
        this.mainTimeList = res.data;
      });
    },
    // 获取合作伙伴图标地址
    getPartnershipList() {
      axios({
        url:
          "/r/cms/www/itn/json/deveConference/partnershipList.json?time=" +
          +new Date(),
        method: "get",
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        withCredentials: true
      }).then(res => {
        this.partnershipList = res.data;
      });
    },
    //从cms上获取嘉宾信息
    getForumGuests() {
      axios({
        url:
          "/r/cms/www/itn/json/deveConference/mainGuests.json?time=" +
          +new Date(),
        method: "get",
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        withCredentials: true
      }).then(res => {
        this.guestsList = (res.data || []).map(item => {
          item.img =
            "/r/cms/www/itn/images/deveConfere/pcMainGuests/" +
            item.img +
            ".png";
          return item;
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.meeting-bg {
  position: relative;
  background: url("../../../assets/developerConference/meeting-bg.jpg")
    no-repeat;
  background-size: cover;
  background-position: center;
}
.common-forum-agenda {
  .main-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    font-family: MicrosoftYaHei;
    padding-bottom: 43px;

    > div:nth-child(1) {
      background-size: cover;
      width: 100px;
      height: 100px;
    }

    > div:nth-child(2) {
      display: flex;
      flex-direction: column;
      width: 240px;
      text-align: justify-all;
      span:nth-child(1) {
        font-size: 28px;
        letter-spacing: 20px;
      }
      span:nth-child(2) {
        font-size: 20px;
        color: rgba($color: #333, $alpha: 0.53);
        letter-spacing: 3px;
      }
    }

    > div:nth-child(3) {
      color: #333333;
      font-family: ArialMT;
    }
    .first-item {
      background: url("../../../assets/developerConference/heavy-icon.png");
      margin-right: 8px;
    }
    .first-icon {
      background: url("../../../assets/developerConference/partners-icon.png");
      margin-right: 5px;
    }
    .second-icon {
      background: url("../../../assets/developerConference/meeting-icon.png");
      margin-right: 5px;
    }
  }

  .coop-partner {
    margin-bottom: 46px;
    display: flex;
    flex-wrap: wrap;
    div {
      width: 224px;
      margin-right: 20px;
      align-items: flex-start;
      // background-color: #fff;
      margin-bottom: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    div:nth-child(5n) {
      margin-right: 0;
    }
  }
  .conference-info {
    // background: #ffffff;
    // border: 1px solid #d2dbe8;
    // border-radius: 3px;
    // margin-bottom: 38px;
    padding-bottom: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .hs-logo {
      width: 196px;
      height: 73px;
      background: url("../../../assets/developerConference/coor_hs_logo.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .hs-qr-code {
      width: 116px;
      height: 116px;
      background: url("../../../assets/developerConference/code_img.jpg")
        no-repeat center;
      background-size: 100% 100%;
      position: relative;
      &:before {
        display: inline-block;
        content: "";
        width: 16px;
        height: 16px;
        background: url("../../../assets/developerConference/code_img_top.png")
          no-repeat center;
        background-size: 100% 100%;
        position: absolute;
        top: -2px;
        left: -2px;
      }
      &:after {
        display: inline-block;
        content: "";
        width: 16px;
        height: 16px;
        background: url("../../../assets/developerConference/code_img_bottom.png")
          no-repeat center;
        background-size: 100% 100%;
        position: absolute;
        bottom: -2px;
        right: -2px;
      }
    }
    .contant-int {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #666666;
      text-align: left;
      line-height: 36px;
      span {
        color: #333333;
      }
      > div {
        &:nth-child(1) {
          &:before {
            display: inline-block;
            content: "";
            width: 23px;
            height: 24px;
            background: url("../../../assets/developerConference/ticket_service.png")
              no-repeat center;
            background-size: 100% 100%;
            vertical-align: middle;
            margin-right: 15px;
          }
        }
        &:nth-child(2) {
          &:before {
            display: inline-block;
            content: "";
            width: 23px;
            height: 24px;
            background: url("../../../assets/developerConference/business_coor.png")
              no-repeat center;
            background-size: 100% 100%;
            vertical-align: middle;
            margin-right: 15px;
          }
        }
        &:nth-child(3) {
          &:before {
            display: inline-block;
            content: "";
            width: 24px;
            height: 23px;
            background: url("../../../assets/developerConference/media_coor.png")
              no-repeat center;
            background-size: 100% 100%;
            vertical-align: middle;
            margin-right: 15px;
          }
        }
      }
    }
  }
}
.main-forum {
  .video-hall {
    height: 740px;
    position: relative;

    .page-header-banner {
      width: 100%;
      min-width: 1200px;
      // min-height: 465px;
      height: 465px;
      background: url("../../../assets/developerConference/main_sub_banner-big.jpg")
        no-repeat center;
      background-size: cover;
    }
    @media screen and (max-width: 1366px) {
      .page-header-banner {
        height: 399px;
        background: url("../../../assets/developerConference/main_sub_banner-small.jpg")
          no-repeat center center;
      }
    }
    .video-part {
      width: 1200px;
      margin: auto;
      position: absolute;
      top: 169px;
      left: 50%;
      transform: translate(-50%);

      .video-title {
        font-family: MicrosoftYaHei-Bold;
        font-size: 44px;
        color: #333333;
        letter-spacing: 0;
        text-align: center;
        font-weight: 700;
        margin-bottom: 30px;
        & > div {
          line-height: 44px;
        }
        span {
          font-size: 28px;
          line-height: 28px;
          font-weight: normal;
        }
      }
      // 播放器
      .video-content {
        width: 100%;
        height: 486px;
        // background: #dddee2;
        display: flex;
        border-radius: 3px;
        position: relative;
        .video-bg {
          background-image: url("../../../assets/developerConference/hall-bg.png");
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
          width: 62%;
          height: 100%;
          img {
            width: 126px;
            height: 40px;
          }
        }
        .watch-video {
          position: relative;
          overflow: hidden;
          flex: 1;
          text-align: center;
          background: url("../../../assets/developerConference/hall-bg.png")
            no-repeat center;
          background-size: 100% 100%;

          .appointment-btn {
            width: 126px;
            height: 40px;
            line-height: 40px;
            border: 1px solid #1f70fd;
            border-radius: 3px;
            font-family: MicrosoftYaHei;
            font-size: 16px;
            background: #1f70fd;
            color: #fff;
            letter-spacing: 0.5px;
            margin: 190px auto 20px;
          }

          p {
            font-family: MicrosoftYaHei;
            font-size: 13px;
            color: #ffffff;
            letter-spacing: 0;
            text-align: center;
            line-height: 24px;
            opacity: 0.8;
          }

          .last-tip {
            position: absolute;
            bottom: 12px;
            left: 21px;
          }
        }

        .video-list {
          width: 439px;
          background-image: url("../../../assets/developerConference/video-list-bg.png");
          background-repeat: no-repeat;
          background-size: cover;
          margin-left: 20px;
          .vid-list-tit {
            height: 60px;
            border-radius: 0 3px 0 0;
            font-family: MicrosoftYaHei-Bold;
            font-size: 22px;
            color: #333;
            text-align: center;
            line-height: 60px;
            display: flex;
            font-weight: 700;
            align-items: center;
            justify-content: center;
            & img {
              margin-right: 10px;
              width: 24px;
              height: 24px;
            }
          }

          .vid-list-content {
            height: 426px;
            overflow: hidden;
            // overflow-y: scroll;
            background-image: linear-gradient(
              -46deg,
              rgba(255, 255, 255, 0.1) 0%,
              rgba(255, 255, 255, 0.4) 100%
            );
            .innerbox {
              overflow-x: hidden;
              overflow-y: auto;
              height: 100%;
              display: flex;
              flex-direction: column;
            }

            /*滚动条样式*/
            .innerbox::-webkit-scrollbar {
              width: 6px;
            }

            .innerbox::-webkit-scrollbar-thumb {
              border-radius: 10px;
              // -webkit-box-shadow: inset 0 0 5px #cccccc;
              background: #cccccc;
            }

            .innerbox::-webkit-scrollbar-track {
              // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
              border-radius: 0;
              background: #fff;
            }

            .li-item {
              height: 80px;
              padding: 20px 0 16px;
              font-family: MicrosoftYaHei;
              font-size: 16px;
              color: #666666;
              text-align: left;
              display: flex;
              align-items: center;
              padding-left: 25px;
              cursor: pointer;

              .play-icon {
                width: 18px;
                height: 18px;
              }
              .play-content {
                padding-left: 26px;
                font-size: 14px;
                display: flex;
                flex-direction: column;
                .play-title {
                  color: #333;
                  margin-bottom: 10px;
                }
                .play-time,
                .play-user-name {
                  color: #666;
                }

                .play-user-name {
                  width: 80px;
                }
              }
            }
            .li-item:hover {
              .play-title,
              .play-time,
              .play-user-name {
                color: #1f70fd;
              }
            }
            .active {
              .play-title,
              .play-time,
              .play-user-name {
                color: #1f70fd !important;
              }
              .play-title {
                font-weight: 700;
              }
              background-image: linear-gradient(
                270deg,
                rgba(66, 169, 255, 0) 0%,
                rgba(31, 112, 253, 0.13) 100%
              );
            }
          }
        }
      }
    }
  }

  .agenda-list {
    margin: 0 auto;
    padding-top: 90px;
    width: 1200px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #333333;
    overflow: hidden;

    .common-guests {
      .main-title {
        display: flex;
        align-items: center;
        font-size: 30px;
        font-family: MicrosoftYaHei;
        padding-bottom: 43px;

        > div:nth-child(1) {
          color: #000000;
          font-weight: 500;
        }

        > div:nth-child(2) {
          width: 3px;
          height: 21px;
          padding: 0 18px;
          background: url("../../../assets/developerConference/division_line.png")
            no-repeat center;
          background-size: contain;
        }

        > div:nth-child(3) {
          color: #333333;
          font-family: ArialMT;
        }
      }
    }

    .sub-forum-guests {
      .sub-guests {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        // justify-content: space-between;

        & > div {
          width: 380px;
          height: 223px;
          box-sizing: border-box;
          background-image: url("../../../assets/developerConference/main-forum-guest-bg.png");
          background-repeat: no-repeat;
          background-size: cover;
          position: relative;
          margin: 0px 10px 30px 10px;
          // margin-bottom: 30px;

          .sub-guests-info {
            position: absolute;
            top: 33px;
            left: 27px;
            width: 130px;

            .sub-guests-name {
              font-family: MicrosoftYaHei-Bold;
              font-size: 24px;
              color: #333333;
              font-weight: 700;
            }

            .sub-guests-position {
              font-family: MicrosoftYaHei;
              font-size: 14px;
              color: #666666;
              margin: 14px 0 17px 0;
            }
            .sub-forum-title {
              font-family: PingFangSC-Medium;
              font-size: 16px;
              color: #333333;
              font-weight: 500;
            }
          }

          img {
            height: 200px;
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/mainForum.vue